import { motion } from "framer-motion";
function RadarGreenWorld() {
    return (
    <div className="relative w-24 h-24 rounded-full overflow-hidden border-2 border-blue-500 shadow-blue-500/50 shadow-md">
        <img
          src="/images/green-world-map.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30" />
        <motion.div
          className="absolute left-1/2 top-1/2 w-0.5 h-full bg-green-400/50 origin-top"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 5, ease: "linear" }}
        />
      </div>
    )}
export default RadarGreenWorld